// TODO: NEED A USER-SERVICE PACAKGE FOR THESE
var UserProfileActionTypes;
(function (UserProfileActionTypes) {
    UserProfileActionTypes["SET_INFO_COMPLETE"] = "USER:PROFILE:COMPLETE";
    UserProfileActionTypes["SET_AVATAR_URL"] = "USER:PROFILE:AVATAR_URL";
    UserProfileActionTypes["SET_AVATAR_URLS"] = "USER:PROFILE:AVATAR_URLS";
    UserProfileActionTypes["SET_ERROR"] = "USER:PROFILE:ERROR";
    UserProfileActionTypes["SET_USER_PROFILE_MEETING_UPDATE"] = "USER:PROFILE_MEETING:SET:UPDATE";
    UserProfileActionTypes["SET_USER_PROFILE_MEETING_COMPLETE"] = "USER:PROFILE_MEETING:SET:COMPLETE";
    UserProfileActionTypes["SET_USER_PROFILE_MEETING_COMPLETE_ERROR"] = "SET_USER_PROFILE_MEETING_COMPLETE_ERROR";
    UserProfileActionTypes["SET_MY_MEETING_ROOM_INFO"] = "USER:PROFILE_MEETING:SET_MY_MEETING_ROOM_INFO";
})(UserProfileActionTypes || (UserProfileActionTypes = {}));
var UserProfileErrorTypes;
(function (UserProfileErrorTypes) {
    UserProfileErrorTypes["SET_INFO_UNKNOWN_ERROR"] = "USER:PROFILE:INFO:UNKNOWN_ERROR";
    UserProfileErrorTypes["SET_INFO_UNDEFINED_PAYLOAD"] = "USER:PROFILE:INFO:UNDEFINED_PAYLOAD";
    UserProfileErrorTypes["SET_AVATAR_UNKNOWN_ERROR"] = "USER:PROFILE:AVATAR:UNKNOWN_ERROR";
    UserProfileErrorTypes["SET_AVATAR_UNDEFINED_ERROR"] = "USER:PROFILE:AVATAR:UNDEFINED_ERROR";
    UserProfileErrorTypes["SET_AVATAR_URLS_UNDEFINED_PAYLOAD"] = "USER:PROFILE:AVATAR_URLS:UNDEFINED_PAYLOAD";
    UserProfileErrorTypes["SET_AVATAR_URLS_UNKNOWN_ERROR"] = "USER:PROFILE:AVATAR_URLS:UNKNOWN_ERROR";
    UserProfileErrorTypes["SET_USER_PROFILE_MEETING_URL_ERROR"] = "USER:PROFILE:MEETING_URL:UNKNOWN_ERROR";
})(UserProfileErrorTypes || (UserProfileErrorTypes = {}));

export { UserProfileActionTypes, UserProfileErrorTypes };
